import React from 'react';
import MDEditor from '@uiw/react-md-editor';

interface MarkdownEditorProps {
  value: string;
  onChange: (value: string | undefined) => void;
  placeholder?: string;
  className?: string;
}

const MarkdownEditor: React.FC<MarkdownEditorProps> = ({
  value,
  onChange,
  placeholder = 'Write your post content here...',
  className = '',
}) => {
  return (
    <div className={`markdown-editor overflow-hidden rounded-[1.5rem] border border-[color:var(--wf-border)] bg-[linear-gradient(180deg,rgba(251,246,238,0.98),rgba(243,233,218,0.94))] shadow-[0_18px_50px_rgba(44,32,27,0.08)] ${className}`} data-color-mode="light">
      <MDEditor
        value={value}
        onChange={onChange}
        height={420}
        preview="edit"
        hideToolbar={false}
        className="!border-0 !bg-transparent"
        textareaProps={{
          placeholder,
          className: 'font-sans text-base',
        }}
      />
    </div>
  );
};

export default MarkdownEditor;
